import { Close } from '@mui/icons-material';
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Modal,
  SxProps,
  Typography,
} from '@mui/material';
import { Fragment, ReactNode } from 'react';
import { useMobileView } from '../../Hooks/useMobileView';

interface KaziModalProps {
  open: boolean;
  handleClose: (props?: any) => void;
  title?: string;
  content: ReactNode;
  actions: ReactNode[];
  stepper?: {
    current: number;
    total: number;
  };
  sx?: SxProps;
  allowCloseFromHeader?: boolean;
  allowCloseOnOutsideClick?: boolean;
}

export const KaziModal = ({
  open,
  handleClose,
  title,
  content,
  actions,
  stepper,
  sx,
  allowCloseFromHeader = true,
  allowCloseOnOutsideClick = false,
}: KaziModalProps) => {
  const { isMobileView } = useMobileView();
  return (
    <Modal
      open={open}
      onClose={allowCloseOnOutsideClick ? handleClose : () => {}}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Card
        sx={{
          width: isMobileView ? '400px' : '600px',
          borderRadius: '12px',
          maxHeight: '95%',
          ...sx,
          overflow: 'auto',
        }}
      >
        <CardHeader
          sx={{
            paddingBottom: 1,
          }}
          action={
            allowCloseFromHeader && (
              <IconButton onClick={handleClose}>
                <Close color="primary" />
              </IconButton>
            )
          }
        />
        <CardContent
          sx={{
            padding: '0 24px',
          }}
        >
          <Grid
            container
            display={'flex'}
            flexDirection={'column'}
            gap={'20px'}
          >
            {title && (
              <Typography
                variant="lora-title-large"
                color={'primary'}
                fontWeight={'bold'}
              >
                {title}
              </Typography>
            )}
            {content}
          </Grid>
        </CardContent>
        <CardActions
          sx={{
            padding: '24px',
          }}
        >
          {stepper && (
            <Box display={'flex'} flexDirection={'row'} width={'100%'}>
              <Typography variant="body-small" color={'black.300'}>
                Step {stepper.current} of {stepper.total}
              </Typography>
            </Box>
          )}
          <Box
            display={'flex'}
            flexDirection={'row'}
            width={'100%'}
            justifyContent={'flex-end'}
            gap={1}
          >
            {
              <>
                {actions.map((action, idx) => (
                  <Fragment key={`KaziModalAction-${idx}`}>{action}</Fragment>
                ))}
              </>
            }
          </Box>
        </CardActions>
      </Card>
    </Modal>
  );
};
